import * as React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { MinhasReservas, NovaReserva } from "../pages";

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={"/pagina-inicial"} element={<MinhasReservas />} />
      <Route path={"/minhas-reservas"} element={<MinhasReservas />} />
      <Route path={"/nova-reserva"} element={<NovaReserva />} />

      <Route path={"/"} element={<Navigate to="/pagina-inicial" />} />
      <Route path={"*"} element={<Navigate to="/pagina-inicial" />} />
    </Routes>
  );
};
